import { __decorate } from "tslib";
// import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import colors from '@/styles/color.scss';
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import lang from '@blade-sxp/monitor-center/lang/index';
import TaskPlayer from '@blade-sxp/monitor/components/player/sei-player.vue';
import { isEmpty } from 'lodash';
import { getRtsp, getSeiRtsp, getRtspMsg } from '@blade-sxp/monitor-center/api/index';
import { getTaskDetail } from '@blade-sxp/task-management/api/queue/index';
import { returnIncidentType } from '@blade-sxp/monitor-center/config/setIncidentType';
import { setRenderType } from '@blade-sxp/monitor-center/config/setRenderType';
import ControlModule from '@blade-sxp/monitor-center/store/index';
import { ControlModule as ControlPage } from '@blade-sxp/monitor/store/control';
import { setTaskMsg } from '@blade-sxp/monitor-center/config/setTaskMsg';
import viewDialog from '@blade-sxp/monitor-center/pages/components/dialog/index.vue';
let default_1 = class default_1 extends Vue {
    selectedDeviced;
    fourScreen;
    fullscreen;
    oneOrfour;
    dragDevicedId;
    dragDevicedName;
    dragDevicedType;
    isDragStyle;
    selectedDevicedArr;
    singleScreenIndex;
    container;
    taskValue = '';
    taskOptions = [];
    fourScreenDragStyleIndex = 0;
    headPointStatus = true;
    polygonData = [];
    zoomRatio = 16 / 9;
    rtspUrl = '';
    extendData = {};
    loading = true;
    viderIndex = 0;
    fullHeight = 0;
    fullWidth = 0;
    renderType = 'frame';
    boxHeight = 0;
    // singleWidth = 835;
    // singleOrdinaryHeight = 835 / this.zoomRatio;
    // fourScreenWidth = 420;
    // fourScreenOrdinaryHeight = 420 / this.zoomRatio;
    singleWidth = 0;
    singleOrdinaryHeight = 0 / this.zoomRatio;
    fourScreenWidth = 0;
    fourScreenOrdinaryHeight = 0 / this.zoomRatio;
    oneVideoArr = [...this.$props.selectedDevicedArr].splice(0, 1);
    mouseStyleImage = require('@blade-sxp/monitor-center/assets/images/mouse.png');
    openSettingIndex = 0;
    msg = {};
    dialogVisible = false;
    alamItem = {};
    currScale = false; // 小于等于16/9：false，大于16/9：true
    videoSettingArr = [];
    get alarmDeviceId() {
        // 告警设备
        return ControlPage.alarmDeviceId;
    }
    onChangeAlarmDeviceId(id) {
        if (!id)
            return;
        const isSelected = this.videoSettingArr.find((item) => item.deviceId === id);
        ControlPage.setAlarmDeviceId('');
        isSelected && this.updateVideoSettingData(id);
    }
    onChangeDevicedArr(list) {
        const videoArr = list
            .filter((item) => item.id)
            .map((item) => {
            const existVideo = this.videoSettingArr.find((setting) => setting.deviceId === item?.id) || {};
            const { status, propertyDisplay, linkageDeviceAlertDelayTime, linkageDeviceAlertDuration, currentDeviceAlertDuration } = item.setting;
            return {
                deviceId: item?.id,
                currentDeviceAlertDuration,
                linkageDevice: item.setting?.linkageDevices?.[0]?.id,
                status,
                propertyDisplay,
                linkageDeviceAlertDelayTime,
                linkageDeviceAlertDuration,
                animationDelay: 0,
                animationDuration: 0,
                ...existVideo,
            };
        });
        this.videoSettingArr = videoArr;
    }
    getStyle(node, index) {
        const currSettingData = this.videoSettingArr.find((item) => item.deviceId === node.id);
        if (!currSettingData)
            return;
        const { animationDelay, animationName, animationDuration, change } = currSettingData;
        return {
            animationDelay: `${animationDelay}s`,
            animationName,
            animationDuration: `${animationDuration}s`,
            animationFillMode: 'forwards',
            animationTimingFunction: 'linear',
            change,
        };
    }
    updateVideoSettingData(id) {
        this.resetVideoSettingStatue();
        this.updateSingleSettingData({ id });
        this.updateSettingAnimation();
    }
    // 重置update状态
    resetVideoSettingStatue() {
        this.videoSettingArr = this.videoSettingArr.map((item) => {
            return { ...item, isUpdate: false };
        });
    }
    updateSingleSettingData(params) {
        const { id, parentId, linkStartTime, linkDuration } = params;
        const currTaskId = ControlPage.alarmTaskId;
        const selectDeviceItem = this.selectedDevicedArr.find((item) => {
            if (parentId) {
                // 联动设备
                return item.id === id && item.taskType === 'FACE_ALERT';
            }
            else {
                return item.id === id && item.taskType === 'FACE_ALERT' && item.taskId === currTaskId;
            }
        }); // 当前需选中人脸比重算法图层
        const currSettingData = this.videoSettingArr.find((item) => item.deviceId === id);
        if (!currSettingData)
            return;
        const currDate = Math.floor(Date.now() / 1000);
        const { alertEndTime, currentDeviceAlertDuration = 10, linkageDevice, linkageDeviceAlertDelayTime, linkageDeviceAlertDuration, alertStartTime, } = currSettingData;
        currSettingData.isUpdate = true;
        // currSettingData?.animationName = 'linkmove';
        if (selectDeviceItem) {
            if (!alertEndTime || alertEndTime < currDate) {
                // 第一次告警 || 告警已结束
                currSettingData.alertStartTime = linkStartTime || currDate; // 告警开始时间为当前时间，如果是联动装置加上联动装置延迟时间
                currSettingData.alertEndTime = linkStartTime ? linkStartTime + Number(linkDuration) : currDate + currentDeviceAlertDuration; // 结束时间：如果是联动装置，则为当前时间+联动延迟+联动报警时长，如果非联动装置，则为当前时间+报警时长
            }
            else if (Number(alertStartTime) <= currDate) {
                // 已开始告警且告警未结束，只需要更新告警结束时间
                const endTime = linkStartTime
                    ? Math.max(linkStartTime + Number(linkDuration) || 0, alertEndTime)
                    : currDate + currentDeviceAlertDuration; // 联动和非联动分开计算
                currSettingData.alertEndTime = endTime;
                currSettingData.alertStartTime = currDate;
            }
            else {
                // 未开始告警
                const startTime = linkStartTime ? Math.min(linkStartTime, Number(alertStartTime)) : currDate;
                const endTime = linkStartTime
                    ? Math.max(linkStartTime + Number(linkDuration), alertEndTime)
                    : Math.max(startTime + currentDeviceAlertDuration, alertEndTime);
                currSettingData.alertStartTime = startTime;
                currSettingData.alertEndTime = endTime;
            }
            if (Number(alertStartTime) < currDate && Number(currSettingData?.alertStartTime) >= currDate) {
                currSettingData.change = !currSettingData?.change;
            }
            if (linkageDevice && !parentId && linkageDevice !== parentId) {
                const linkStartTime = Number(currSettingData?.alertStartTime) + linkageDeviceAlertDelayTime;
                this.updateSingleSettingData({ id: linkageDevice, parentId: id, linkStartTime, linkDuration: linkageDeviceAlertDuration });
            }
        }
        // else {
        //   currSettingData.alertStartTime = currDate;
        //   currSettingData.alertEndTime = currDate;
        //   currSettingData.change = !currSettingData?.change;
        // }
    }
    updateSettingAnimation() {
        const currDate = Math.floor(Date.now() / 1000);
        this.videoSettingArr.forEach((item) => {
            if (!item.isUpdate)
                return;
            const { alertStartTime, alertEndTime, change, animationDelay } = item;
            this.$set(item, 'animationDelay', Number(alertStartTime) >= currDate ? Number(alertStartTime) - currDate : Number(animationDelay));
            this.$set(item, 'animationName', change ? 'linkmove' : 'linkmove2');
            this.$set(item, 'animationDuration', Number(alertEndTime) - Number(alertStartTime));
        });
    }
    dragStyle(index) {
        return {
            background: this.isDragStyle && index === this.fourScreenDragStyleIndex ? colors.boderYellow : colors.white,
            border: this.isDragStyle && index === this.fourScreenDragStyleIndex ? `2px dashed ${colors.searchYellow}` : 'none',
            display: !this.fourScreen && index !== this.singleScreenIndex ? 'none' : 'flex',
            flex: 'wrap',
            justifyContent: this.fourScreen && this.fullscreen ? (index === 1 || index === 3 ? 'flex-start' : 'flex-end') : '',
            alignItems: this.fourScreen && this.fullscreen ? (index === 0 || index === 1 ? 'flex-end' : 'flex-start') : '',
        };
    }
    // 删除视频流
    delDevice(item) {
        let ind = this.selectedDevicedArr.findIndex((ele) => ele.id === item.id);
        this.selectedDeviced?.splice(ind, 1, '');
        this.selectedDevicedArr.splice(ind, 1, { title: '', rtsp: '', id: '' });
        this.polygonData = [];
    }
    getContentStyle() {
        return {
            width: this.fullscreen ? '100vw' : '',
            // maxWidth: this.fullscreen ? '' : '980px',
            height: this.fullscreen && !this.fourScreen ? '100vh' : '',
        };
    }
    async mounted() {
        const selectedDevicedArr = ControlModule.selectedDevicedArr || [];
        const index = selectedDevicedArr.findIndex((item) => {
            return item.id !== '';
        });
        if (index !== -1) {
            await this.changeMsg();
            // this.changeTask(this.selectedDevicedArr[this.singleScreenIndex], this.singleScreenIndex);
        }
        this.$nextTick(() => {
            this.resizeObserve();
        });
    }
    resizeObserve() {
        const dom = this.container;
        let observer = new ResizeObserver(this.calcContainerScale);
        observer.observe(dom, { box: 'border-box' });
    }
    calcContainerScale() {
        if (!this.container)
            return;
        this.boxHeight = this.container.offsetHeight - 9; // 留出border和视频流之间的距离
        this.singleWidth = this.container.offsetWidth - 9;
        this.currScale = this.singleWidth / this.boxHeight > this.zoomRatio;
    }
    contentStyle() {
        if (!this.boxHeight || !this.singleWidth)
            return;
        return {
            width: this.getContentWidth(),
            height: this.getContentHeight(),
        };
    }
    getTaskSize() {
        // 视频需要传入宽高
        if (!this.boxHeight || !this.singleWidth)
            return;
        if (this.fourScreen) {
            return {
                width: this.getContentWidth(0.5),
                height: this.getContentHeight(0.5),
            };
        }
        else {
            return {
                width: this.getContentWidth(),
                height: this.getContentHeight(),
            };
        }
    }
    getContentWidth(scale = 1) {
        return !this.currScale ? this.singleWidth * scale + 'px' : this.boxHeight * this.zoomRatio * scale + 'px';
    }
    getContentHeight(scale = 1) {
        return this.currScale ? this.boxHeight * scale + 'px' : (this.singleWidth / this.zoomRatio) * scale + 'px';
    }
    changeMsg() {
        this.selectedDevicedArr.forEach((videoStreams, index) => {
            if (videoStreams.id !== '') {
                this.changeRtspMsg(videoStreams, index);
            }
        });
    }
    changeRtspMsg(data, index) {
        getRtspMsg([data.id])
            .then((res) => {
            // 更新任务
            let taskMsgArr = [];
            const noLayer = {
                name: `${this.$t('noLayer')}`,
                id: 0,
            };
            res[data.id]?.forEach((item) => {
                let incidentType = returnIncidentType(item.taskType);
                this.$set(item, 'incidentType', incidentType);
                taskMsgArr.push(item);
            });
            taskMsgArr.unshift(noLayer);
            const videoStreamObjTaskMsg = setTaskMsg(taskMsgArr);
            // this.selectedDevicedArr[index].taskMsg = videoStreamObjTaskMsg;
            this.$set(this.selectedDevicedArr[index], 'taskMsg', videoStreamObjTaskMsg);
            if (this.selectedDevicedArr[index].taskId) {
                const taskItem = videoStreamObjTaskMsg.find((item) => item?.id === this.selectedDevicedArr[index].taskId);
                if (!taskItem) {
                    this.$set(this.selectedDevicedArr[index], 'taskId', '');
                }
            }
            // console.log('modelType1', this.selectedDevicedArr[index]);
        })
            .then(() => {
            this.changeTask(this.selectedDevicedArr[index], index);
        });
    }
    setCanvasStyle(width, height, zoomRatio) {
        const wrapperRatio = width / height; // 容器宽高比
        // console.log('wrapperRatio', wrapperRatio);
        const imageRatio = zoomRatio || 16 / 9; // 视频宽高比
        let canvasHeight = 0;
        let canvasWidth = 0;
        if (this.fullscreen && this.fourScreen) {
            // console.log('imageRatio', imageRatio);
            canvasWidth = width - 2;
            canvasHeight = width / imageRatio;
        }
        else {
            if (wrapperRatio < imageRatio) {
                canvasHeight = width / imageRatio;
                canvasWidth = canvasHeight * imageRatio;
            }
            else if (wrapperRatio > imageRatio) {
                canvasWidth = height * imageRatio;
                canvasHeight = canvasWidth / imageRatio;
            }
            else {
                canvasHeight = height;
                canvasWidth = width;
            }
        }
        let canvasStyle = {
            width: canvasWidth,
            height: canvasHeight,
        };
        // console.log(canvasStyle);
        return canvasStyle;
    }
    changeScreen(fourScreen) {
        this.$emit('update:fourScreen', fourScreen);
        // console.log('点击2', this.fourScreen);
    }
    handlePlaying(video, id) {
        this.loading = false;
        this.selectedDevicedArr.forEach((item) => {
            if (item.id === id) {
                this.$set(item, 'zoomRatio', video.videoWidth / video.videoHeight);
            }
        });
    }
    // 左右切换视频流
    goArrow(direction, id) {
        this.refreshDeviced();
        this.fourScreen = false;
        if (direction === 'left') {
            this.$parent.changesingleScreenIndex(this.singleScreenIndex - 1);
        }
        else {
            this.$parent.changesingleScreenIndex(this.singleScreenIndex + 1);
        }
    }
    // 从四屏去全屏
    gofullScreen(index) {
        this.$parent.changesingleScreenIndex(index);
        this.refreshDeviced();
        if (this.fullscreen) {
            // 全屏四屏
            this.$emit('update:fourScreen', false);
        }
        else {
            // 正常四屏
            this.$emit('update:fourScreen', false);
            this.$parent.enlarge();
        }
    }
    changeFullscreen(fullscreen) {
        this.refreshDeviced();
    }
    changeFourScreen(fourScreen) {
        // console.log('改变', fourScreen);
        this.refreshDeviced();
        if (fourScreen) {
            this.fullHeight = (window.screen.height - 36) / 2;
            this.fullWidth = window.screen.width / 2;
        }
        else {
            this.fullHeight = window.screen.height - 36;
            this.fullWidth = window.screen.width;
        }
    }
    refreshDeviced() {
        this.selectedDevicedArr.forEach((item) => {
            if (!isEmpty(item.extendData)) {
                this.$set(item, 'keyId', this.genID(this.viderIndex));
            }
        });
        ControlPage.clearSelectMap();
    }
    changeTask(item, index) {
        this.selectedDevicedArr[index].polygonData = [];
        // let roiArr: nodeItem[] = [];
        this.$set(this.selectedDevicedArr[index], 'rtsp', 'rtsp://');
        this.selectedDevicedArr[index].taskType = '';
        if (item.taskId) {
            this.viderIndex = index;
            const videoSettingItem = this.videoSettingArr.find((setting) => setting.deviceId === item.id);
            videoSettingItem && this.$set(videoSettingItem, 'animationName', '');
            const polygonData = this.selectedDevicedArr[index].taskMsg.find((taskItem) => {
                return taskItem.id === item.taskId;
            });
            const renderType = setRenderType(polygonData.taskType);
            // console.log('modelType2', polygonData.modelType);
            this.$set(this.selectedDevicedArr[index], 'renderType', renderType);
            let extendData = this.selectedDevicedArr[index].extendData || {};
            this.selectedDevicedArr[index].polygonData = polygonData.polygonData;
            this.selectedDevicedArr[index].taskType = polygonData.taskType;
            getSeiRtsp(String(this.selectedDevicedArr[index].id), item.taskId).then((res) => {
                if (this.renderType === 'behavior') {
                    getTaskDetail(item.taskId).then((taskDetail) => {
                        let deviceTaskConfigs = taskDetail.deviceTaskConfigs.find((item) => {
                            return item.deviceId === this.selectedDevicedArr[index].id;
                        });
                        extendData = {
                            roiIdArr: polygonData.roiArr,
                            incidentType: polygonData.incidentType,
                            deviceTaskConfigs: deviceTaskConfigs,
                        };
                    });
                }
                else {
                    extendData = {
                        roiIdArr: polygonData.roiArr,
                        incidentType: polygonData.incidentType,
                        modelType: polygonData?.modelType || '',
                    };
                }
                if (polygonData.incidentType === 'FACE_ALERT') {
                    extendData.drawAttributes = this.selectedDevicedArr[index]?.setting?.propertyDisplay === 'ENABLE';
                    extendData.drawRect = this.selectedDevicedArr[index]?.setting?.status === 'ENABLE';
                }
                else {
                    extendData.drawAttributes = true;
                    extendData.drawRect = false;
                }
                // console.log('1111 deviceId:', item.id);
                extendData.taskId = item.taskId;
                extendData.deviceId = item.id;
                this.$set(this.selectedDevicedArr[index], 'rtsp', res.rtspPreviewAddress);
                this.$set(this.selectedDevicedArr[index], 'extendData', extendData);
                this.$set(this.selectedDevicedArr[index], 'keyId', this.genID(index));
            });
        }
        else {
            getRtsp(String(this.selectedDevicedArr[index].id)).then((res) => {
                this.$set(this.selectedDevicedArr[index], 'extendData', {});
                this.$set(this.selectedDevicedArr[index], 'rtsp', res.rtspPreviewAddress);
            });
        }
    }
    dragleave(e) {
        // 当拖拽离开这个div时执行的事件
        this.$parent.changeIsDragStyle(false);
    }
    dragover(e, index) {
        // 拖拽在这个div里面拖拽时执行的事件
        // 一定要执行preventDefault(),否则drop事件不会被触发
        e.preventDefault();
        this.fourScreenDragStyleIndex = index;
        this.$parent.changeIsDragStyle(true);
        e.dataTransfer.dropEffect = 'move';
    }
    // 生成唯一ID
    genID(length) {
        return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
    }
    outFullScreen() {
        this.$emit('enlarge');
    }
    drop(e, index) {
        // 在div里拖拽停止时执行的事件
        this.$parent.changeIsDragStyle(false);
        if (this.selectedDeviced?.includes(this.dragDevicedId) || this.dragDevicedType === 'DEVICE_GROUP') {
            return false;
        }
        getRtsp(String(this.dragDevicedId)).then((res1) => {
            getRtspMsg([this.dragDevicedId]).then((res) => {
                // 加一部分任务
                let taskMsgArr = [];
                // console.log('taskMsgArr', res);
                res[String(this.dragDevicedId)]?.forEach((item) => {
                    let incidentType = returnIncidentType(item.taskType);
                    this.$set(item, 'incidentType', incidentType);
                    taskMsgArr.push(item);
                });
                let videoStreamObj = {
                    title: String(this.dragDevicedName),
                    rtsp: res1.rtspPreviewAddress,
                    id: String(this.dragDevicedId),
                    taskMsg: taskMsgArr,
                    taskId: '',
                    extendData: {},
                    polygonData: [],
                };
                this.selectedDevicedArr.splice(index, 1, videoStreamObj);
                this.selectedDeviced?.splice(index, 1, this.dragDevicedId);
            });
        });
    }
    openSetting(item, index) {
        // console.log('item', item);
        this.openSettingIndex = index;
        this.msg = item;
        this.dialogVisible = true;
        this.alamItem = {};
    }
    submitSetting(msg) {
        // 人脸设置设置的算法层参数
        const selectDeviceItem = this.selectedDevicedArr?.find(({ id }) => id === msg.deviceId);
        let settingItem = this.videoSettingArr?.find(({ deviceId }) => deviceId === msg.deviceId);
        if (!selectDeviceItem)
            return;
        const setting = {
            ...msg,
            linkageDevices: [
                {
                    id: msg.linkageDevice[0],
                },
            ],
        };
        const rtsp = selectDeviceItem.rtsp;
        this.$set(selectDeviceItem, 'rtsp', 'rtsp://');
        this.$set(selectDeviceItem, 'setting', setting);
        if (settingItem) {
            settingItem.currentDeviceAlertDuration = setting.currentDeviceAlertDuration;
            settingItem.linkageDevice = msg.linkageDevice[0];
            settingItem.status = setting.status;
            settingItem.propertyDisplay = setting.propertyDisplay;
            settingItem.linkageDeviceAlertDelayTime = setting.linkageDeviceAlertDelayTime;
            settingItem.linkageDeviceAlertDuration = setting.linkageDeviceAlertDuration;
        }
        if (selectDeviceItem?.extendData?.incidentType === 'FACE_ALERT') {
            this.$set(selectDeviceItem, 'extendData', {
                ...selectDeviceItem.extendData,
                drawAttributes: msg.propertyDisplay === 'ENABLE',
                drawRect: msg.status === 'ENABLE',
            });
        }
        this.$nextTick(() => {
            this.$set(selectDeviceItem, 'rtsp', rtsp);
        });
    }
    closeDialog() {
        this.alamItem = {};
    }
    beforeDestroy() {
        ControlModule.updateSelectedDevicedArr(this.selectedDevicedArr);
        ControlModule.updateSelectedDevice(this.selectedDeviced);
        // console.log('销毁前', ControlModule.selectedDevicedArr);
    }
};
__decorate([
    Prop()
], default_1.prototype, "selectedDeviced", void 0);
__decorate([
    Prop()
], default_1.prototype, "fourScreen", void 0);
__decorate([
    Prop()
], default_1.prototype, "fullscreen", void 0);
__decorate([
    Prop()
], default_1.prototype, "oneOrfour", void 0);
__decorate([
    Prop({ default: '', type: String })
], default_1.prototype, "dragDevicedId", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedName", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedType", void 0);
__decorate([
    Prop()
], default_1.prototype, "isDragStyle", void 0);
__decorate([
    Prop()
], default_1.prototype, "selectedDevicedArr", void 0);
__decorate([
    Prop()
], default_1.prototype, "singleScreenIndex", void 0);
__decorate([
    Ref()
], default_1.prototype, "container", void 0);
__decorate([
    Watch('alarmDeviceId')
], default_1.prototype, "onChangeAlarmDeviceId", null);
__decorate([
    Watch('selectedDevicedArr', { deep: true })
], default_1.prototype, "onChangeDevicedArr", null);
__decorate([
    Watch('fullscreen', { immediate: true })
], default_1.prototype, "changeFullscreen", null);
__decorate([
    Watch('fourScreen', { immediate: true })
], default_1.prototype, "changeFourScreen", null);
default_1 = __decorate([
    Component({
        name: 'videoStream',
        components: { TaskPlayer, viewDialog },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
